<template>
    <div class="conferencePage" v-if="data && data.page">
        <div class="speakersCont">
            <div class="speakers">
                <h2 class="helvetica title3">Speakers and Presentations</h2>
                <ItemSpeaker v-for="speaker in data?.page.speakers" :speaker="speaker" />
            </div>
        </div>
        <WebsiteFooter />
    </div>
</template>

<script lang="ts" setup>
const { getConferenceSpeakers } = useConferences();
const route = useRoute()
const { data } = useAsyncData(`conferences-${route.params.slug}-speakers`, () => getConferenceSpeakers(route.params.slug));

useSeoMeta({
    title: () => `Speakers: ${data.value?.page?.title} | Conferences | EIC Federation`,
    ogTitle: () => `Speakers: ${data.value?.page?.title} | Conferences | EIC Federation`,
    twitterTitle: () => `Speakers: ${data.value?.page?.title} | Conferences | EIC Federation`
})
</script>

<style lang="scss" scoped>
.conferencePage {
    .speakersCont {
        padding: 0 var(--size-margin-page);

        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: var(--size-gutter-double) var(--size-margin-page);

        .speakers {
            grid-column: 2;

            display: grid;
            grid-template-columns: repeat(6, minmax(0, 1fr));
            gap: var(--size-gutter-double) var(--size-margin-page);

            h2, .speaker {
                grid-column: span 5;
            }
        }
    }
}


@media screen and (max-width: 600px) {
    .conferencePage {
        .speakersCont {
            .speakers {
                display: grid;
                grid-column: span 5;
                grid-template-columns: repeat(5, minmax(0, 1fr));
            }
        }
    }
}
</style>